import React, { useContext } from 'react';

import { UserContext } from 'Context/user';

import { formatPrice } from 'Utilities/formatPrice';

import { DealerVerification } from 'Storybook/components/local/DealerVerification';

import { DocumentCaptureOfferContext } from '../DocumentCaptureContexts';

export const DealerVerificationContainer = () => {
  const { userState } = useContext(UserContext);
  const { acceptedBid } = useContext(DocumentCaptureOfferContext);

  const sellerName = userState?.firstName ?? '';
  const { dealer, value } = acceptedBid || {};
  const dealerName = dealer?.name ?? '';

  if (!dealerName || !sellerName || !value) {
    return null;
  }

  return <DealerVerification {...{ dealerName, sellerName, value: formatPrice(value) }} />;
};
